"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _dropdownMenu = _interopRequireDefault(require("../dropdownMenu"));
var _loader = require("../loader");
var _FormContext = _interopRequireDefault(require("./FormContext"));
var _components = require("./components");
var _Spinner;
const FormAutocomplete = _ref => {
  let {
    value,
    placeholder,
    spellcheck,
    autocapitalize,
    className,
    maxlength,
    readOnly,
    icon,
    match,
    state,
    required,
    managed,
    selectOnFocus,
    onChange,
    onGetOptions,
    onGetLabel,
    onOptionSelected,
    onBlur,
    onFocus
  } = _ref;
  const inputElement = /*#__PURE__*/_react.default.createRef();
  const rootElementRef = /*#__PURE__*/_react.default.createRef();
  const optionContainerRef = /*#__PURE__*/_react.default.createRef();
  const {
    controlId,
    isFocus,
    onBlur: onInputBlur,
    onFocus: onInputFocus,
    setState,
    onRequiredChange
  } = _react.default.useContext(_FormContext.default);
  const internalValueOptions = _react.default.useMemo(() => ({
    locked: managed !== true && isFocus
  }), [isFocus, managed]);
  const [internalValue, setInternalValue] = (0, _arkReact.useInternalValueManager)(value, internalValueOptions);
  const [options, setOptions] = _react.default.useState({
    isLoading: false,
    isOpen: false,
    options: []
  });
  _react.default.useEffect(() => setState?.(state), [state]);
  _react.default.useEffect(() => onRequiredChange?.(required ?? false), [required, onRequiredChange]);
  const textChanged = _react.default.useCallback(newValue => onChange?.(newValue), [onChange]);
  _react.default.useEffect(() => {
    if (!(0, _ark.isFunction)(onGetOptions) || !isFocus) return;
    (async function execute() {
      setOptions(prevState => Object.assign({}, prevState, {
        isOpen: true,
        isLoading: true
      }));
      const options = await onGetOptions(internalValue || '');
      setOptions(prevState => Object.assign({}, prevState, {
        isLoading: false,
        options
      }));
    })();
  }, [internalValue, isFocus]);
  const onInputChange = _react.default.useCallback(async event => {
    const {
      value: inputValue
    } = event.target;
    if ((0, _ark.isNumber)(maxlength) && inputValue.length > maxlength) return;
    setInternalValue(inputValue);
    setOptions(prevState => Object.assign({}, prevState, {
      isOpen: true
    }));
    textChanged(inputValue);
  }, [setInternalValue, onGetOptions, setOptions, textChanged, maxlength]);
  const onItemClick = _react.default.useCallback((text, optionItem, event) => {
    if ((0, _ark.isString)(text)) {
      setInternalValue(text);
      textChanged(text);
    }
    if ((0, _ark.isDefined)(optionItem)) {
      onOptionSelected?.(optionItem);
    }
    setOptions(prevState => Object.assign({}, prevState, {
      isOpen: false
    }));
    onInputBlur?.();
    onBlur?.(text ?? '', event);
  }, [setInternalValue, setOptions, onOptionSelected, textChanged]);
  const childrenOptions = _react.default.useMemo(() => options.options.map((optionItem, idx) => {
    const text = onGetLabel?.(optionItem) ?? ((0, _ark.isString)(optionItem) ? optionItem : '');
    return /*#__PURE__*/_react.default.createElement(_components.SelectOption, {
      id: text,
      key: idx,
      value: text,
      onClick: (_, event) => onItemClick(text, optionItem, event)
    }, text);
  }), [options, onItemClick, onGetLabel]);
  const textLength = _react.default.useMemo(() => {
    return (0, _ark.isString)(internalValue) ? internalValue.length : 0;
  }, [internalValue]);
  const showLengthIndicator = _react.default.useMemo(() => isFocus && readOnly !== true && (0, _ark.isNumber)(maxlength), [readOnly, isFocus, maxlength]);
  const handleInputBlur = _react.default.useCallback(event => {
    const {
      relatedTarget
    } = event;
    if ((0, _ark.isDefined)(optionContainerRef.current) && optionContainerRef.current.contains(relatedTarget)) return;
    onInputBlur?.();
    onBlur?.(internalValue ?? '', event);
  }, [onInputBlur, onBlur, internalValue, optionContainerRef]);
  const handleInputFocus = _react.default.useCallback(event => {
    if (selectOnFocus === true) {
      inputElement.current?.select();
    }
    onInputFocus?.();
    onFocus?.(event);
  }, [onInputFocus, onFocus, selectOnFocus, inputElement.current]);
  const handleInputClick = () => {
    setOptions(prevState => Object.assign({}, prevState, {
      isOpen: true
    }));
  };
  const handleCloseMenu = event => {
    const {
      target
    } = event;
    if ((0, _ark.isDefined)(rootElementRef.current) && rootElementRef.current.contains(target)) return;
    setOptions(prevState => Object.assign({}, prevState, {
      isOpen: false
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: rootElementRef,
    className: "formAutocomplete"
  }, /*#__PURE__*/_react.default.createElement("input", {
    ref: inputElement,
    id: controlId,
    type: "text",
    name: controlId,
    className: (0, _arkReact.concatClassName)('formControl formInput', className),
    placeholder: placeholder,
    autoComplete: "off",
    value: internalValue ?? '',
    spellCheck: spellcheck,
    autoCapitalize: autocapitalize,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    onChange: onInputChange,
    onClick: handleInputClick,
    readOnly: readOnly
  }), icon != null && /*#__PURE__*/_react.default.createElement("div", {
    className: "formInputIcon"
  }, icon), icon == null && options.isLoading && (_Spinner || (_Spinner = /*#__PURE__*/_react.default.createElement(_loader.Spinner, {
    className: "formSpinner"
  }))), showLengthIndicator && /*#__PURE__*/_react.default.createElement("span", {
    className: "formInputLength"
  }, textLength, "/", maxlength), !readOnly && childrenOptions.length > 0 && /*#__PURE__*/_react.default.createElement(_dropdownMenu.default, {
    ref: optionContainerRef,
    open: options.isOpen,
    anchorEl: controlId,
    onClose: handleCloseMenu,
    className: "formDropdownMenu"
  }, childrenOptions));
};
process.env.NODE_ENV !== "production" ? FormAutocomplete.propTypes = {
  value: _propTypes.default.string,
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  spellcheck: _propTypes.default.bool,
  autocapitalize: _propTypes.default.oneOf(['none', 'sentences', 'words', 'characters']),
  maxlength: _propTypes.default.number,
  readOnly: _propTypes.default.bool,
  icon: _propTypes.default.node,
  match: _propTypes.default.bool,
  required: _propTypes.default.bool,
  state: _propTypes.default.oneOf(['error', 'warning', 'ok']),
  managed: _propTypes.default.bool,
  selectOnFocus: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onGetOptions: _propTypes.default.func,
  onOptionSelected: _propTypes.default.func,
  onGetLabel: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func
} : void 0;
FormAutocomplete.defaultProps = {
  value: undefined,
  className: undefined,
  placeholder: undefined,
  spellcheck: undefined,
  autocapitalize: undefined,
  maxlength: undefined,
  readOnly: undefined,
  icon: undefined,
  match: undefined,
  required: false,
  state: 'ok',
  managed: false,
  selectOnFocus: false,
  onChange: undefined,
  onGetOptions: undefined,
  onOptionSelected: undefined,
  onGetLabel: undefined,
  onFocus: undefined,
  onBlur: undefined
};
var _default = exports.default = FormAutocomplete;